<template>
    <div class="block">
        <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pagesize"
            layout="prev, pager, next"
            :total="total"
            :current-page="now"
        >
        </el-pagination>
    </div>
</template>

<script>
import { defineComponent, toRef } from "vue";

export default defineComponent({
    name: "withPagination",
    props: {
        hitsTotal: {
            type: Number,
            require: true,
        },
        currentPageSize: {
            type: Number,
            require: true,
        },
        nowpage: {
            type: Number,
            required: true,
        },
    },
    setup(props, context) {
        const handleCurrentChange = (val) => {
            context.emit("emittedhadleCurrentChange", val);
        };
        const total = toRef(props, "hitsTotal");
        const pagesize = toRef(props, "currentPageSize");
        const now = toRef(props, "nowpage");

        return {
            handleCurrentChange,
            total,
            pagesize,
            now,
        };
    },
});
</script>

<style scoped></style>
